module.exports = __webpack_public_path__ + "static/media/box_01.92bca9c8.png";